export const appDataMockUp = {
    forumQuestions: [
        {
            active: null,
            id: null,
            text: null
        }
    ],
    forumStartTime: null,
    forumSchedule: [
        {
            label: null,
            agenda: [
                {
                    itemType: 1,
                    panels: [],
                    startTime: null,
                    endTime: null,
                    label: null
                },
                {
                    itemType: 2,
                    startTime: null,
                    endTime: null,
                    label: null
                }
            ]
        }
    ],
    forumLocation: null,
    forumPeriod: null,
    forumPanels: {
        1: {
            speakers: [],
            code: null,
            description: null,
            startTimeLabel: null,
            startTime: null,
            label: null,
            endTime: null,
            room: null,
            moderators: []
        }
    },
    forumSpeakers: {
        1: {
            imgUrl: null,
            panelsAsSpeaker: [],
            panelsAsModerator: [],
            name: null,
            biography: null,
            title: null
        }
    }
};
